import { motion } from "framer-motion";

const DOTS = Array.from({ length: 14 }, (_, i) => {
  const a = (i / 14) * Math.PI * 2;
  return { x: Math.cos(a) * 70, y: Math.sin(a) * 70, d: 0.55 + (i % 4) * 0.05 };
});

// Booking celebration shown on the thank-you screen after a T&T Calendlo booking.
export default function BookedBurst({ text, accent }) {
  return (
    <div className="flex items-center gap-5 mb-6" data-testid="calendlo-booked">
      <div className="relative w-20 h-20 shrink-0">
        {DOTS.map((p, i) => (
          <motion.span key={i} className="absolute left-1/2 top-1/2 w-1.5 h-1.5 rounded-full" style={{ background: accent }}
            initial={{ x: 0, y: 0, opacity: 0, scale: 0 }} animate={{ x: p.x * 0.6, y: p.y * 0.6, opacity: [0, 1, 0], scale: [0, 1.2, 0.4] }}
            transition={{ delay: p.d, duration: 0.9, ease: "easeOut" }} />
        ))}
        <motion.svg viewBox="0 0 80 80" className="w-20 h-20" initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 260, damping: 16 }}>
          <motion.circle cx="40" cy="40" r="34" fill="none" stroke={accent} strokeWidth="4" strokeLinecap="round"
            initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 0.55, ease: "easeInOut" }} />
          <motion.path d="M26 41 L36 51 L55 31" fill="none" stroke={accent} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"
            initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ delay: 0.45, duration: 0.4, ease: "easeOut" }} />
        </motion.svg>
      </div>
      <motion.div className="text-2xl sm:text-3xl font-medium tracking-tight" style={{ color: accent }}
        initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        data-testid="calendlo-booked-text">{text}</motion.div>
    </div>
  );
}
